import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { SayfalamaSonuc } from '@models_genel/SayfalamaSonuc'
import { DuyuruInfo } from '@core/models/genel/DuyuruInfo';
import { IslemSonuc } from '@core/models/genel/IslemSonuc';
import { DuyuruAramaKriterInfo } from '@core/models/fatura/DuyuruAramaKriterInfo';

@Injectable()
export class DuyurularService {

  constructor(private http: HttpClient) {
  }

  getData(aramaKriter: DuyuruAramaKriterInfo): Observable<SayfalamaSonuc> {
    return this.http.post<SayfalamaSonuc>(environment.API_DUYURULAR_URL + 'GetDuyurular', aramaKriter);
  }
  select(id: number): Observable<DuyuruInfo> {
    return this.http.get<DuyuruInfo>(environment.API_DUYURULAR_URL + id.toString());
  }
  ekleGuncelle(entity: DuyuruInfo): Observable<any> {
    return this.http.post<DuyuruInfo>(environment.API_DUYURULAR_URL, entity);
  }
  sil(id: number): Observable<any> {
    return this.http.delete<any>(environment.API_DUYURULAR_URL + id.toString());
  }
  okunduBilgisiniEkle(duyuruId: any): Observable<IslemSonuc> {
    return this.http.get<IslemSonuc>(environment.API_DUYURULAR_URL + 'okundubilgisiekle/' + duyuruId.toString());
  }
  okunmamisDuyuruGetir(parametersModel?: any): Observable<DuyuruInfo> {
    return this.http.get<DuyuruInfo>(environment.API_DUYURULAR_URL + 'okunmamisduyurugetir', { params: parametersModel });
  }

  buroKontorKontrol(): Observable<any> {
		return this.http.get<any>(
			environment.API_DUYURULAR_URL+"burokontorkontrol/"
		);
	}

	kullaniciKontorMiktarKontrol(): Observable<any> {
		return this.http.get<any>(
			environment.API_DUYURULAR_URL+"kullanicikontormiktarkontrol/"
		);
	}

  getGenelDuyuru(): Observable<any> {
      return this.http.get<any>(
        environment.API_DUYURULAR_URL+"genelduyurugetir/"
      );
	}

}
